/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ViewAsPatientPayload
 */
export interface ViewAsPatientPayload {
    /**
     * 
     * @type {string}
     * @memberof ViewAsPatientPayload
     */
    url?: string;
}

/**
 * Check if a given object implements the ViewAsPatientPayload interface.
 */
export function instanceOfViewAsPatientPayload(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ViewAsPatientPayloadFromJSON(json: any): ViewAsPatientPayload {
    return ViewAsPatientPayloadFromJSONTyped(json, false);
}

export function ViewAsPatientPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): ViewAsPatientPayload {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}

export function ViewAsPatientPayloadToJSON(value?: ViewAsPatientPayload | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
    };
}

